import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { indexOf } from 'lodash';
import Shimmer from '../shimmer';
import { loadObject } from './actions';
import { getObjectStatus, getObjectData } from './reducer';
import styles from './styles.css';
import MoneyDisplay from '../money-display';
import DateTimeDisplay from '../date-time-display';
import NumberDisplay from '../number-display';

const OPPORTUNITY_TYPE = 'OPPORTUNITY';
const ACCOUNT_TYPE = 'ACCOUNT';
const OWNER_TYPE = 'OWNER';
const PRODUCT_TYPE = 'PRODUCT';
const COMPETITOR_TYPE = 'COMPETITOR';


function convertType(targetObject) {
  let type = null;
  if (targetObject === 'OpportunityCompetitor') {
    type = COMPETITOR_TYPE;
  } else if (targetObject === 'Account') {
    type = ACCOUNT_TYPE;
  } else if (targetObject === 'Product') {
    type = PRODUCT_TYPE;
  } else if (targetObject === 'User') {
    type = OWNER_TYPE;
  } else if (targetObject === 'Opportunity') {
    type = OPPORTUNITY_TYPE;
  }
  return type;
}

const validLocalFields = [
  'name', 'amount', 'close_date',
  'country_code', 'name', 'stage',
  'owner_id', 'account_id',
];

class DynamicCell extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  loadObject() {
    const type = convertType(this.props.column.target_object);
    if (type) {
      loadObject(this.props.id, type, this.props.dispatch);
    }
  }

  render() {
    const {
      object, status, height, width,
      column, isLocal, localObject,
    } = this.props;
    if (!isLocal) {
      this.loadObject();
    }
    const data = isLocal && localObject ? localObject : object;

    const isLoading = !isLocal && (status !== 'loaded' || !data);

    const availableHeight = Number.isNaN(height) ? null : Math.max(0, height - 16);
    const maxWidth = Number.isNaN(width) ? null : Math.max(0, width - 16);
    const fontSize = 12;
    const lineHeight = fontSize * 1.5;
    const maxHeight = availableHeight ? Math.floor(availableHeight / lineHeight) * lineHeight : null;
    if (isLoading) {
      return (
        <div style={{ width: maxWidth || null }}>
          <Shimmer value="pending" full />
        </div>
      );
    }
    const targetField = column.target_field;
    const metaType = column.type;
    let displayStr = data[targetField];
    if (displayStr === undefined && data.searchable) {
      displayStr = data.searchable[targetField];
    }


    let comp = null;
    if (metaType === 'currency') {
      comp = (<MoneyDisplay value={displayStr} />);
    } else if (metaType === 'date') {
      comp = (<DateTimeDisplay value={displayStr} format="short" />);
    } else if (metaType === 'int') {
      comp = (<NumberDisplay value={displayStr} precision={0} />);
    } else if (metaType === 'double' || metaType === 'number') {
      comp = (<NumberDisplay value={displayStr} precision={2} />);
    } else if (metaType === 'percent') {
      comp = (<NumberDisplay value={displayStr} precision={1} suffix="%" />);
    } else if (metaType === 'email') {
      comp = (
        <a
          className={styles.truncate}
          href={`mailto:${displayStr}`}
          style={{
            display: 'block',
            fontSize: `${fontSize}px`,
            maxHeight,
            maxWidth: maxWidth || null,
            lineHeight: `${lineHeight}px`,
          }}
        >
          {displayStr}
        </a>
      );
    } else if (metaType === 'boolean') {
      if (displayStr === true) {
        comp = (<span className="label label-success">YES</span>);
      } else {
        comp = (<span className="label label-danger">NO</span>);
      }
    } else if (metaType === 'id') {
      comp = (<code>{displayStr}</code>);
    } else {
      comp = (
        <span
          className={styles.truncate}
          style={{
            fontSize: `${fontSize}px`,
            maxHeight: maxHeight || null,
            maxWidth: maxWidth || null,
            lineHeight: `${lineHeight}px`,
          }}
        >
          {displayStr}
        </span>
      );
    }

    return comp;
  }
}

function mapStateToProps(state, ownProps) {
  const type = convertType(ownProps.column.target_object);
  let isLocal = false;
  if (ownProps.column.target_object === 'Opportunity' &&
    indexOf(validLocalFields, ownProps.column.target_field) >= 0) {
    isLocal = true;
  }
  return {
    object: getObjectData(state, type, ownProps.id),
    status: getObjectStatus(state, type, ownProps.id),
    isLocal,
  };
}

DynamicCell.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  column: PropTypes.shape({
    type: PropTypes.string,
    target_object: PropTypes.string.isRequired,
    target_field: PropTypes.string.isRequired,
  }).isRequired,
  status: PropTypes.string,
  object: PropTypes.shape({}),
  localObject: PropTypes.shape({}),
  isLocal: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
};
DynamicCell.defaultProps = {
  status: null,
  object: null,
  height: null,
  width: null,
  isLocal: false,
  localObject: null,
};

DynamicCell.OPPORTUNITY_TYPE = OPPORTUNITY_TYPE;
DynamicCell.ACCOUNT_TYPE = ACCOUNT_TYPE;
DynamicCell.OWNER_TYPE = OWNER_TYPE;
DynamicCell.PRODUCT_TYPE = PRODUCT_TYPE;
DynamicCell.COMPETITOR_TYPE = COMPETITOR_TYPE;

export default connect(mapStateToProps)(DynamicCell);
